// extracted by mini-css-extract-plugin
export default {"sectionText":"LuxuriesPage_sectionText__lj9Gv","subTitleText":"LuxuriesPage_subTitleText__D0ZR2"};